import { InvoiceFormConfig } from '../types';
import {
	laborConfig,
	partsConfig,
	equipmentConfig,
	travelConfig,
	freightConfig,
	miscellaneousConfig,
} from '../../SupplierInvoiceFormNew/CostSectionConfigs';
import { LINE_ITEM_FIELD } from '../../../utils/InvoiceUtils';

// Note: Proposals use "incurred" section which needs a different config
// For now, we'll use misc config as placeholder - this should be created separately
const incurredConfig = {
	...miscellaneousConfig,
	label: 'Incurred Cost',
};

export const createProposalConfig = (
	formData: any,
	workOrder: any,
	currentUser: any,
	history: any,
	onSubmit: (values: any, formInstance: any) => Promise<any>,
	options?: {
		redirectForwardUrl?: string;
		creating?: boolean;
		updating?: boolean;
		createErrors?: string[];
		updateErrors?: string[];
		onSuccess?: (record: any) => void;
		onError?: (error: any) => void;
	}
): InvoiceFormConfig => {
	return {
		formType: 'proposal',
		fields: {
			scope: true,
			invoiceNumber: false,
			externalWorkOrderId: false,
			invoiceDate: false,
			paymentTerms: false,
			dueDate: false,
			fileAttachments: true,
		},
		lineItemSections: [
			{ type: 'incurred', show: true, config: incurredConfig },
			{ type: 'labor', show: true, config: laborConfig },
			{ type: 'parts', show: true, config: partsConfig },
			{ type: 'equipment', show: true, config: equipmentConfig },
			{ type: 'travel', show: true, config: travelConfig },
			{ type: 'freight', show: true, config: freightConfig },
			{ type: 'misc', show: true, config: miscellaneousConfig },
		],
		tax: {
			type: 'lineItems',
			// Proposals might not need tax line items fetching, but included for consistency
		},
		currency: {
			fetchInternally: true,
			source: 'supplierFacility',
		},
		onSubmit,
		formData,
		workOrder,
		currentUser,
		history,
		redirectForwardUrl: options && options.redirectForwardUrl,
		creating: options && options.creating,
		updating: options && options.updating,
		createErrors: options && options.createErrors,
		updateErrors: options && options.updateErrors,
		onSuccess: options && options.onSuccess,
		onError: options && options.onError,
	};
};
